var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatutesButtonIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1819 2.90909C10.1819 1.30245 11.4843 0 13.091 0C14.6976 0 16.0001 1.30245 16.0001 2.90909C16.0001 4.51574 14.6976 5.81819 13.091 5.81819C11.4843 5.81819 10.1819 4.51574 10.1819 2.90909ZM11.6366 2.9091C11.6366 3.71242 12.2879 4.36364 13.0912 4.36364C13.8945 4.36364 14.5457 3.71242 14.5457 2.9091C14.5457 2.10577 13.8945 1.45455 13.0912 1.45455C12.2879 1.45455 11.6366 2.10577 11.6366 2.9091Z",
    fill: "#4D4DE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0909 7.27255C12.6893 7.27255 12.3636 7.59816 12.3636 7.99983V14.5453H1.45455V3.63619H8.00001C8.40167 3.63619 8.72728 3.31058 8.72728 2.90891C8.72728 2.50725 8.40167 2.18164 8.00001 2.18164H0.727273C0.325611 2.18164 0 2.50725 0 2.90891V15.2726C0 15.6742 0.325611 15.9998 0.727273 15.9998H13.0909C13.4926 15.9998 13.8182 15.6742 13.8182 15.2726V7.99983C13.8182 7.59816 13.4926 7.27255 13.0909 7.27255Z",
    fill: "#4D4DE6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatutesButtonIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/statutesButtonIcon.026d8900de27a5b80313925c687a97b8.svg";